import React, { useState, useMemo } from 'react';
import { Paper, Typography, Box, Button, TextField } from '@mui/material';
import PlayersSelector from './PlayersSelector';
import ScoreBoard from './ScoreBoard';
import api from '../../api';
import { useNavigate } from 'react-router-dom';

/**
 * MatchSimple
 * - choose class / players
 * - set pointsToWin (default 21)
 * - start match -> live scoring UI (add point to player A / B)
 * - track history and display scoreboard
 * - save result via API (POST /badminton/matches) if desired (placeholder)
 */
export default function MatchSimple() {
  const [selectedClasse, setSelectedClasse] = useState('');
  const [player1, setPlayer1] = useState('');
  const [player2, setPlayer2] = useState('');
  const [pointsToWin, setPointsToWin] = useState(21);
  const [started, setStarted] = useState(false);
  const [scoreA, setScoreA] = useState(0);
  const [scoreB, setScoreB] = useState(0);
  const [history, setHistory] = useState([]);
  const navigate = useNavigate();

  const playerAName = useMemo(() => player1 || 'Joueur 1', [player1]);
  const playerBName = useMemo(() => player2 || 'Joueur 2', [player2]);

  const addPoint = (who, pts = 1, reason = 'point') => {
    const time = new Date().toLocaleTimeString();
    if (who === 'A') setScoreA(s => s + pts);
    else setScoreB(s => s + pts);
    setHistory(h => [{ who, pts, reason, time }, ...h]);
  };

  const checkWinner = () => {
    if (scoreA >= pointsToWin || scoreB >= pointsToWin) {
      if (scoreA > scoreB) return 'A';
      if (scoreB > scoreA) return 'B';
      return null;
    }
    return null;
  };

  const winner = checkWinner();

  const saveResult = async () => {
    try {
      const payload = {
        type: 'MATCH_SIMPLE',
        classe: selectedClasse,
        joueurA: player1,
        joueurB: player2,
        scoreA,
        scoreB,
        history
      };
      // placeholder endpoint - adapte si tu as un endpoint backend
      await api.post('/badminton/matches', payload);
      alert('Résultat enregistré');
      navigate('/apps/badminton');
    } catch (err) {
      console.error('Erreur save match', err);
      alert('Erreur enregistrement (voir console)');
    }
  };

  return (
    <Paper sx={{ p: 2, mt: 3 }}>
      <Typography variant="h6">Match simple</Typography>

      {!started ? (
        <Box sx={{ mt: 2, display: 'grid', gap: 2 }}>
          <PlayersSelector
            selectedClasse={selectedClasse}
            setSelectedClasse={setSelectedClasse}
            player1={player1}
            setPlayer1={setPlayer1}
            player2={player2}
            setPlayer2={setPlayer2}
          />

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <TextField label="Points pour gagner" type="number" value={pointsToWin} onChange={e => setPointsToWin(Number(e.target.value || 1))} />
            <Button variant="contained" disabled={!selectedClasse || !player1 || !player2} onClick={() => setStarted(true)}>Démarrer le match</Button>
          </Box>
        </Box>
      ) : (
        <Box sx={{ mt: 2 }}>
          <ScoreBoard playerAName={playerAName} playerBName={playerBName} scoreA={scoreA} scoreB={scoreB} history={history} />

          <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
            <Button color="success" variant="contained" onClick={() => addPoint('A')}>+1 {playerAName}</Button>
            <Button color="error" variant="contained" onClick={() => addPoint('B')}>+1 {playerBName}</Button>
            <Button variant="outlined" onClick={() => { setStarted(false); setHistory([]); setScoreA(0); setScoreB(0); }}>Terminer</Button>
          </Box>

          {winner && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1">Gagnant : {winner === 'A' ? playerAName : playerBName}</Typography>
              <Button variant="contained" onClick={saveResult}>Enregistrer le résultat</Button>
            </Box>
          )}
        </Box>
      )}
    </Paper>
  );
}